import { MyCanvas } from "./slot/MyCanvas";


export function InvalidateCanvas(canvas: HTMLCanvasElement | MyCanvas)
{
    if (!canvas) {
        console.log("canvas is empty");
        return;
    }

    if (canvas instanceof MyCanvas)
    {
        console.log("canvas is mycanvas");
        return InvalidateCanvas(canvas.Canvas());
    }

    let originalWidth: number = canvas.width;
    let originalHeight: number = canvas.height;

    canvas.width = originalWidth +1;
    canvas.height = originalHeight +1;

    setTimeout(() => {
        canvas.width = originalWidth;
        canvas.height = originalHeight;
    });
}

export function VerifyCanvasContext(canvas: MyCanvas)
{
    let imageData = canvas.context.getImageData(0, 0, 1, 1);
    
    let ok = 
        imageData.data[0] != 0 &&
        imageData.data[1] != 0 &&
        imageData.data[2] != 0 &&
        imageData.data[3] != 0;

    return ok;
}

export function SetCanvasVerification(canvas: MyCanvas)
{


    let imageData = canvas.context.getImageData(0, 0, 1, 1);
    imageData.data[0] = 127,
    imageData.data[1] = 127,
    imageData.data[2] = 127,
    imageData.data[3] = 127

    canvas.context.putImageData(imageData, 0, 0);
}


(window as any).InvalidateCanvas = InvalidateCanvas;


export class AssertError extends Error {
    constructor(message) {
      super(message); // (1)
      this.name = "ValidationError"; // (2)
    }
}

export function assertNotNullish(value: any, message?: string)
{
    if (!value)
    {
        debugger;
        throw new AssertError(message ?? "Value is null");
    }
}

export function assertEqual<T>(expected: T, actual: T, message?: string)  
{
    if (expected !== actual)
    {
        debugger;
        throw new AssertError(message ?? `Expected ${actual} to be equal to ${expected}`);
    }
}

export function assertNotEqual<T>(expected: T, actual: T, message?: string)  
{
    if (expected === actual)
    {
        debugger;
        throw new AssertError(message ?? `Expected ${actual} to not be equal to ${expected}`);
    }
}

export function assertNotLess<T>(limit: T, actual: T, message?: string)  
{
    if (actual < limit)
    {
        debugger;
        throw new AssertError(message ?? `Expected ${actual} to be not less than ${limit}`); 
    }
}

export function assertNotMore<T>(limit: T, actual: T, message?: string)
{
    if (actual > limit)
    {
        debugger;
        throw new AssertError(message ?? `Expected ${actual} to be not more than ${limit}`); 
    }
}

export function assertNever(message?: string)
{
    throw new AssertError(message ?? "Unexpected code path, should never be reached.");
}

export function assertTrue(condition: boolean, message?: string)
{
    if (!condition)
    {
        debugger;
        //throw new AssertError(message ?? "Expected true");
    }
}
